import React, { useEffect } from 'react';
import { Form } from 'semantic-ui-react';

import { useDispatch, useSelector } from 'react-redux';
import { FormProvider, useForm } from 'react-hook-form';
import ChatBox from 'shared/TextingComponents/ChatBox';
import textActions from 'actions/text';
import { convertRecipientContactVariables } from 'utils/TextFormUtils';
import { generateResolver } from 'dyl-components';
import { FileUtils } from 'utils';
import { FILE_CATEGORIES } from 'utils/FileUtils';
import templateCategoryActions from "actions/template_category" 
import tcrActions from "actions/tcr"

const TextTab = ({ recipientId, recipientName, recipientOptions = [], }) => {
    const officeViewConversationRecipient = useSelector(state => state.text.officeViewConversationRecipient);
    const officeViewConversationSender = useSelector(state => state.text.officeViewConversationSender);
    const textPhones = useSelector(state => state.text.phones || []);
    const defaultRecipient = recipientOptions.find(option => option.main)?.phone || recipientOptions[0]?.phone || undefined;
    const defaultSender = textPhones.length > 0 ? textPhones[0] : '';
    const methods = useForm({
        defaultValues: {
            message: '',
            attachments: [],
            user: "all"
        },
        mode: 'onChange',
        resolver: generateResolver({
            attachments: FileUtils.getFilesizeValidator(FILE_CATEGORIES.TEXT)
        })
    });

    const selectedUser = methods.watch('user');
    const messages = useSelector(state => state.text.filteredMessagesForTextOfficeView || []);
    const isReadingMessages = useSelector(state => state.text.isReadingMessagesForTextOfficeView);
    
    const isLoadingRecipientDetails = useSelector(state => state.text.isReadingOfficeViewTextRecipientPhones);

    const userOptions = useSelector(state => state.text.textOfficeViewUserOptions);
    const detailsOfContactRecipient = useSelector(state => state.text.officeViewContact);
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(templateCategoryActions.readCategorizedTemplates({ category: 'text' }));
        dispatch(tcrActions.getBrand()).then((data) => {
            dispatch(tcrActions.getBrandOptOutStatus(data?.brandId))
        })
    }, [dispatch])
    
    return (
        <FormProvider {...methods}>
            <Form>
                <ChatBox 
                    onReadMessages={(contact_phone, customer_phone) => {
                        dispatch(textActions.getFilteredMessagesForTextOfficeView({ contact_phone, customer_phone }));
                        dispatch(textActions.setConversationBeingViewedInOfficeView({ contact_phone, customer_phone }));
                    }}
                    userOptions={userOptions}
                    recipientOptions={recipientOptions}
                    messages={selectedUser !== "all" ? messages.filter(msg => msg.user_id === selectedUser || msg.direction === 'inbound') : messages}
                    isReadingMessages={isReadingMessages}
                    recipientId={recipientId}
                    recipientName={recipientName}
                    isLoadingRecipientDetails={isLoadingRecipientDetails}
                    onReplaceRecipientVariable={(variable) => {
                        return convertRecipientContactVariables(variable, detailsOfContactRecipient);
                    }}
                    isOfficeView
                    from={officeViewConversationSender || defaultSender}
                    to={officeViewConversationRecipient || defaultRecipient}
                    onChangeNumbers={(payload) => {
                        dispatch(textActions.getFilteredMessagesForTextOfficeView(payload));
                        dispatch(textActions.setConversationBeingViewedInOfficeView(payload));
                    }}
                />
            </Form>
        </FormProvider>
    );
};

export default TextTab;
